import { Entry } from 'contentful'

export enum ContentfulLocale {
  EN_GB = 'en-GB',
  EN_US = 'en-US',
}

export type ContentfulEntry<T = any> = Entry<T>
export interface ContentfulObject {
  sys: { contentType?: { sys: { id: string } } }
}

export interface ContentfulPageContent<T = any> extends ContentfulObject {
  fields: T
}

export interface ContentfulPageSEO extends ContentfulObject {
  fields: {
    name: string
    title: string
    description: string
  }
}

export interface ContentfulPage<T = any> {
  name: string
  title: string
  slug: string
  content: ContentfulPageContent<T>
  seo: ContentfulPageSEO
}

export interface ContentfulImage {
  fields: { file?: { url: string }; description: string; title: string }
}

export const contentTypeOf = (contentfulObject?: ContentfulObject) => {
  return contentfulObject?.sys.contentType?.sys.id
}

export enum ContentfulPageType {
  homePublicGb = 'pageHomeLoggedOut',
  homePrivateGb = 'pageHomeLoggedIn',
  homePublicUs = 'pageHomeLoggedOutUs',
  homePrivateUS = 'pageHomeLoggedInUs',
}
